import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { Modal } from "antd"
import { InputDatePicker } from "jalaali-react-date-picker";
import moment from "moment-jalaali";

import * as actions from "../../actions";
import * as Template from "../../templates";
import { formatNumber, websiteBaseUrl } from '../../libraries/helper';
import { useLocation } from "react-router-dom";


export default () => {

  const moduleName = "invoices";

  const appReducer = useSelector((state) => state.appReducer, shallowEqual);

  const dispatch = useDispatch();

  const [rows, setRows] = useState([])
  const [tableSelectedRows, setTableSelectedRows] = useState([])
  const [shippings, setShippings] = useState([])
  const [totalPages, setTotalPages] = useState(0)
  const location = useLocation()
  const [expireAt, setExpireAt] = useState();
  const [deliveredAt, setDeliveredAt] = useState();
  const [startAt, setStartAt] = useState();
  const [productId, setProductId] = useState(0);
  const [lgShow, setLgShow] = useState(false);
  const [latitude, setLatitude] = useState();
  const [longitude, setLongitude] = useState();
  const [lgStepShow, setLgStepShow] = useState(false);
  const [lgUserShow, setLgUserShow] = useState(false);
  const [user, setUser] = useState();
  const [trackingPost, setTrackingPost] = useState();
  const [adminNote, setAdminNote] = useState();
  
  const [state, setState] = useState(``);
  const [platform, setPlatform] = useState(`website`);
  const [shipping, setShipping] = useState();
  const [stateInvoiceId, setStateInvoiceId] = useState(``);
  const [submitted, setSubmitted] = useState(false);
  const [issuanceDate, setIssuanceDate] = useState(moment());
  const [products, setProducts] = useState([])
  const [deliveredTime, setDeliveredTime] = useState([])

  const handleChangeShipping = (value) => {
    setShipping(value)
  }

  const handleSelectRows = ({ selectedRows }) => {
    setTableSelectedRows(selectedRows)
  }

  const handlePrintAll = () => {
    if (tableSelectedRows.length) {
      let ids = []
      tableSelectedRows.map(item => ids.push(`billNumbers[]=${item.billNumber}`))
      window.location.href = `${websiteBaseUrl}/invoice/print-bulk/?${ids.join("&")}`
    }
  }

  const handlePrintPostAll = () => {
    if (tableSelectedRows.length) {
      let ids = []
      tableSelectedRows.map(item => ids.push(`billNumbers[]=${item.billNumber}`))
      window.location.href = `${websiteBaseUrl}/invoice/post-print-bulk/?${ids.join("&")}`
    }
  }

  const handleTotalPrint = () => {
    if (tableSelectedRows.length) {
      let ids = []
      tableSelectedRows.map(item => ids.push(`billNumbers[]=${item.billNumber}`))
      window.location.href = `${websiteBaseUrl}/invoice/warehose-bulk/?${ids.join("&")}`
    }
  }

  const handleChangeDeliveredTime = (value) => setDeliveredTime(value)

  const changeModal = (status, invoiceId) => {
    setLgShow(status);
    setProductId(invoiceId)
  };

  const handleClick = () => {
    setSubmitted(true)
    dispatch(actions.update(stateInvoiceId, moduleName));
  };

  const changeUserModal = (status, invoiceId) => {
    setLatitude(undefined)
    setLongitude(undefined)
    if (invoiceId > 0) {
      dispatch(actions.edit(invoiceId, `invoices`));
    }
    setLgUserShow(status);
  };


  useEffect(() => {
    if (user != undefined) {
      setLatitude(parseFloat(user.address.latitude))
      setLongitude(parseFloat(user.address.longitude))
    }
  }, [user])

  const changeStepModal = (status, invoice, activeStep) => {

    setLgStepShow(status);

    let invoiceState = "تایید‌شده"

    switch (activeStep) {
      case "cancelled":
        invoiceState = "لغو شده"
        break;
      case "preview":
        invoiceState = "پیش‌ فاکتور"
        break;
      case "waiting":
        invoiceState = "در حال بررسی"
        break;
      case "accept":
        invoiceState = "تایید شده"
        break;
      case "trash":
        invoiceState = "زباله‌دان"
        break;
      case "packaging":
        invoiceState = "بسته‌بندی"
        break;
      case "stopped":
        invoiceState = "متوقف‌شده"
        break;
      case "preparation":
        invoiceState = "آماده‌سازی"
        break;
      case "ready_to_send":
        invoiceState = "آماده ارسال"
        break;
      case "peyk":
        invoiceState = "تحویل پیک"
        break;
      case "sent":
        invoiceState = "ارسال شده"
        break;
      case "post":
        invoiceState = "تحویل اداره پست"
        break;
      case "delivered":
        invoiceState = "پایان مراحل"
        break;
      case "customer_blocked":
        invoiceState = "عدم پاسخگویی"
        break;
      case "considering":
        invoiceState = "بررسی بیشتر"
        break;
    }

    setState({
      value: activeStep,
      label: invoiceState,
    })
    if (invoice != undefined) {
      setIssuanceDate(moment(invoice.issuance_date))
      setStateInvoiceId(invoice.id)
      setTrackingPost(invoice.tracking_post)
      setAdminNote(invoice.admin_note)
    }
  };

  useEffect(() => {
    if (productId > 0) {
      dispatch(actions.edit(productId, 'invoices/product'));
    }
  }, [productId]);


  useEffect(() => {
    dispatch(actions.list(moduleName, location.search));
    dispatch(actions.list('shippings'));
    if (appReducer.invoices_update != undefined && submitted) {
      changeStepModal(false)
      window.location.reload()
    }
  }, [appReducer.invoices_publish, appReducer.invoices_update, appReducer.invoices_unpublish, location.search]);


  const handlePublish = (id) => dispatch(actions.publish(id, moduleName));

  const handleunPublish = (id) => {
    dispatch(actions.unpublish(id, moduleName))
  };

  const handleChangeState = (value) => setState(value);

  const handleChangePlatform = (value) => setPlatform(value);

  useEffect(() => {
    if (appReducer.invoices_edit != undefined) {
      setUser(appReducer.invoices_edit.data)
    }
  }, [appReducer.invoices_edit]);

  useEffect(() => {
    if (appReducer.shippings_list != undefined) {

      let shippingItems = []

      appReducer.shippings_list.data.map(shipping => shippingItems.push({
        label: shipping.name,
        value: shipping.id
      }))

      setShippings(shippingItems)
    }
    if (appReducer.invoices_list != undefined) {
      setRows(appReducer.invoices_list.data)
      setTotalPages(appReducer.invoices_list.count)
    }
    if (appReducer.invoices_product_edit != undefined) {
      setProducts(appReducer.invoices_product_edit.data)
    }
  }, [appReducer])



  const columns = [
    {
      name: 'ردیف',
      selector: row => row.id,
    },
    {
      name: 'شماره سفارش',
      selector: row => row.billNumber,
    },
    {
      name: 'توضیحات',
      selector: row => row.admin_note != '' ? ""  : "دارد",
    },
    {
      name: 'روش پرداخت',
      selector: row => row.gateway,
    },
    {
      name: 'کد رهگیری',
      selector: row => row.tracking_number ?? "-",
    },
    {
      name: 'مشتری',
      selector: row => row.address.info,
    },
    {
      name: 'وضعیت سفارش',
      selector: row => {

        let invoiceState = "در حال بررسی"

        switch (row.state) {
          case "cancelled":
            invoiceState = "لغو شده"
            break;
          case "preview":
            invoiceState = "پیش‌ فاکتور"
            break;
          case "waiting":
            invoiceState = "در حال بررسی"
            break;
          case "accept":
            invoiceState = "تایید شده"
            break;
          case "trash":
            invoiceState = "زباله‌دان"
            break;
          case "packaging":
            invoiceState = "بسته‌بندی"
            break;
          case "stopped":
            invoiceState = "متوقف‌شده"
            break;
          case "preparation":
            invoiceState = "آماده‌سازی"
            break;
          case "ready_to_send":
            invoiceState = "آماده ارسال"
            break;
          case "peyk":
            invoiceState = "تحویل پیک"
            break;
          case "sent":
            invoiceState = "ارسال شده"
            break;
          case "post":
            invoiceState = "تحویل اداره پست"
            break;
          case "delivered":
            invoiceState = "پایان مراحل"
            break;
          case "customer_blocked":
            invoiceState = "عدم پاسخگویی"
            break;
          case "considering":
            invoiceState = "بررسی بیشتر"
            break;
        }

        return <span className="text text-blue-600">{invoiceState}</span>

      },
    },
    {
      name: 'تاریخ‌',
      selector: row => <div className="flex flex-col space-y-5">
        <span> سفارش: {row.issuance_date_fa}</span>
        <span> بروزرسانی: {row.updated_at}</span>
      </div>,
    },
    {
      name: 'مبلغ کل',
      selector: row => `${formatNumber(row.total_price)} تومان`,
    },
    {
      name: 'پرداخت',
      selector: row => `${formatNumber(row.payable)} تومان`,
    },
    {
      name: 'مبلغ تخفیف',
      selector: row => `${formatNumber(row.discount)} تومان ${row.discount > 0 ? `( کد تخفیف: ${row.voucher.hash} )` : ""}`,
    },
    {
      name: 'هزینه ارسال',
      selector: row => `${formatNumber(row.shipping_price)} تومان ${row.shipping_price > 0 ? `( ${row.shipping.name} )` : ""}`,
    },
    {
      name: 'وضعیت پرداخت',
      selector: row => {

        if (row.payed == 1) {
          return <span className="text text-green-500">پرداخت موفق</span>
        }

        if (row.payed == 0) {
          return <span className="text text-red-500">پرداخت نشده</span>
        }

        if (row.payed == 2) {
          return <span className="text text-amber-500">در انتظار کارت به کارت </span>
        }
      },
    },
    {
      name: 'پلتفرم',
      selector: row => row.platform == "website" ? "وب‌سایت" : "اپلیکیشن",
    },
    {
      name: 'تاریخ ارسال',
      selector: row => <div>{row.delivery_date ? row.delivery_date : "-"} {row.delivery_time ? row.delivery_time : ""}</div>,
    },
    {
      name: 'نوع تحویل',
      selector: row => row.shipping ? row.shipping.name: "-",
    },
    {
      name: 'عملیات',
      selector: row => <div className="flex flex-wrap py-5 space-y-3 flex-col">

        <button onClick={() => changeModal(true, row.id)} type="button" className="bg-gradient-to-tr from-blue-300  text-xs to-blue-400 hover:opacity-75 border text-sm  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700" data-hs-overlay="#hs-basic-modal">
          اقلام
        </button>

        <Template.Button
          onClick={() => changeUserModal(true, row.id)}
          label="جزییات"
          background="bg-gradient-to-tr from-green-300 to-green-400  text-xs"
        />

        <Template.Button
          onClick={() => changeStepModal(true, row, row.state)}
          label="ویرایش"
          background="bg-gradient-to-tr from-indigo-300 to-indigo-400  text-xs"
        />

        <a target="new" href={websiteBaseUrl + `/invoice/post-print/` + row.billNumber} className="bg-gradient-to-tr from-teal-300 to-teal-400 hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">برچسب</a>

        <a target="new" href={websiteBaseUrl + `/invoice/print/` + row.billNumber} className=" hover:opacity-75 border text-xs  font-bold  px-3 py-3 flex justify-center items-center rounded-md text-gray-700 ">چاپ</a>

        {row.state == 'waiting' && row.payed == 1 ? <Template.Button onClick={() => handlePublish(row.id)} label="تایید" background="bg-gradient-to-tr from-green-300 to-green-400  text-xs" /> : ''}

        {row.state == 'waiting' && row.payed == 2 ? <Template.Button onClick={() => handlePublish(row.id)} label="تایید پرداخت کارت به کارت" background="bg-gradient-to-tr from-amber-300 to-amber-400 text-xs" /> : ''}

        {row.state != 'cancelled' ? <Template.Button onClick={() => handleunPublish(row.id)} label="کنسل" background="bg-gradient-to-tr from-rose-300 to-rose-400  text-xs" /> : ''}


      </div>,
    },
  ];


  const productColumns = [
    {
      name: 'تصویر',
      selector: row => <img className="h-32" src={row.product_price.url_full ? row.product_price.url_full : row.product_price.product.active_image} />,
    },
    {
      name: 'عنوان',
      selector: row => `${row.product_price.product.name} ${row.product_price.attribute_item ? ' | ' + row.product_price.attribute_item.name : ''}  ${' | ' + row.product_price.name}`,
    },
    {
      name: 'نام فروشنده',
      selector: row => row.product_price.user.business.name,
    },
    {
      name: 'کد محصول',
      selector: row => row.product_price.product.code,
    },
    {
      name: 'کد تنوع',
      selector: row => row.product_price.code,
    },
    ,
    {
      name: 'تعداد سفارش',
      selector: row => row.quantity,
    },
  ]

  return (
    <div>

      <Modal
        title="مشاهده اقلام"
        open={lgShow}
        width={1000}
        centered
        footer={[<div></div>]}
        onCancel={() => changeModal(false, 0)}
      >
        <Template.Table columns={productColumns} data={products} />

      </Modal>

      <Modal
        title="اطلاعات سفارش"
        centered
        open={lgUserShow}
        footer={[<div></div>]}
        onCancel={() => changeUserModal(false, 0)}
      >
        {user != undefined && <div>
          <ul className="flex flex-col space-y-5">
            <li>نام گیرنده‌: {user.address.info}</li>
            <li> کدملی: {user.address.identity}</li>
            <li>استان : {user.address.city.province.name}</li>
            <li>شهر : {user.address.city.name}</li>
            <li>آدرس : {user.address.address}</li>
            <li>موبایل : {user.address.mobile}</li>
            <li>کدپستی : {user.address.zipcode}</li>
          </ul>
        </div>}
      </Modal>



      <Modal
        title="بروزرسانی سفارش"
        width={1000}
        open={lgStepShow}
        footer={[<div></div>]}
        centered
        onCancel={() => changeStepModal(false, 0)}
      >
        <Template.Form>
          <fieldset>
            <label>تاریخ صدور <i className="star">*</i></label>
            <InputDatePicker onChange={(e) => setIssuanceDate(e)} defaultValue={issuanceDate} />
            <input
              type="hidden"
              name="issuance_date"
              defaultValue={issuanceDate.format("YYYY-MM-DD")}
            />
          </fieldset>
          <Template.Input label="کد رهگیری پست" value={trackingPost} name="tracking_post" type="text" />
          <Template.Input label="توضیحات مدیر" value={adminNote}  name="admin_note" type="text" />

          <Template.SingleSelect
            withLabel
            required
            placeholder="مرحله جدید"
            onChange={handleChangeState}
            name="state"
            value={state}
            options={[
              {
                value: "accept",
                label: "تایید‌شده",
              },
              {
                value: "preview",
                label: "پیش‌ فاکتور",
              },
              {
                value: "cancelled",
                label: "لغوشده",
              },
              {
                value: "waiting",
                label: "در حال بررسی",
              },
              {
                value: "trash",
                label: "زباله‌دان",
              },
              {
                value: "packaging",
                label: "بسته‌بندی",
              },
              {
                value: "peyk",
                label: "تحویل پیک",
              },
              {
                value: "preparation",
                label: "آماده‌سازی",
              },
              {
                value: "ready_to_send",
                label: "آماده ارسال",
              },
              {
                value: "considering",
                label: "بررسی بیشتر",
              },
              {
                value: "sent",
                label: "ارسال‌شده",
              },
              {
                value: "post",
                label: "تحویل اداره پست",
              },
              {
                value: "stopped",
                label: "متوقف شده",
              },
              {
                value: "delivered",
                label: "پایان مراحل",
              },
              {
                value: "customer_blocked",
                label: "عدم پاسخگویی",
              },
            ]}
          />
          <Template.Button
            label="ذخیره"
            onClick={handleClick}
          />
        </Template.Form>
      </Modal>

      <Template.Filter moduleName={moduleName}>
        <Template.Input
          label="ردیف"
          placeholder="ردیف"
          name="id"
          type="text"
        />
        <Template.Input
          label="شماره سفارش"
          placeholder="شماره سفارش"
          name="billNumber"
          type="text"
        />
        <Template.Input
          label="کد رهگیری"
          placeholder="کد رهگیری"
          name="tracking_number"
          type="text"
        />
        <Template.SingleSelect
          withLabel
          placeholder="وضعیت سفارش"
          onChange={handleChangeState}
          name="state"
          value={state}
          options={[
            {
              value: "accept",
              label: "تایید‌شده",
            },
            {
              value: "preview",
              label: "پیش‌ فاکتور",
            },
            {
              value: "cancelled",
              label: "لغوشده",
            },
            {
              value: "waiting",
              label: "در حال بررسی",
            },
            {
              value: "trash",
              label: "زباله‌دان",
            },
            {
              value: "packaging",
              label: "بسته‌بندی",
            },
            {
              value: "peyk",
              label: "تحویل پیک",
            },
            {
              value: "preparation",
              label: "آماده‌سازی",
            },
            {
              value: "ready_to_send",
              label: "آماده ارسال",
            },
            {
              value: "considering",
              label: "بررسی بیشتر",
            },
            {
              value: "sent",
              label: "ارسال‌شده",
            },
            {
              value: "post",
              label: "تحویل اداره پست",
            },
            {
              value: "stopped",
              label: "متوقف شده",
            },
            {
              value: "delivered",
              label: "پایان مراحل",
            },
          ]}
        />
        <Template.Input
          label="اطلاعات مشتری"
          placeholder="اطلاعات مشتری"
          name="name"
          type="text"
        />
        <Template.SingleSelect
          withLabel
          placeholder="پلتفرم فروش"
          onChange={handleChangePlatform}
          name="platform"
          value={platform}
          options={[
            {
              value: "website",
              label: "وب‌سایت",
            },
            {
              value: "app",
              label: "اپلیکیشن",
            }
          ]}
        />
        <fieldset>
          <label className="text-gray-500">تاریخ شروع <i className="star">*</i></label>
          <InputDatePicker onChange={(e) => setStartAt(e)} defaultValue={startAt} />
          <input
            type="hidden"
            name="start_at"
            defaultValue={startAt ? startAt.format("YYYY-MM-DD") : ""}
          />
        </fieldset>

        <fieldset>
          <label className="text-gray-500">تاریخ پایان <i className="star ">*</i></label>
          <InputDatePicker onChange={(e) => setExpireAt(e)} defaultValue={expireAt} />
          <input
            type="hidden"
            name="expire_at"
            defaultValue={expireAt ? expireAt.format("YYYY-MM-DD") : ""}
          />
        </fieldset>

        <fieldset>
          <label className="text-gray-500">تاریخ ارسال <i className="star ">*</i></label>
          <InputDatePicker onChange={(e) => setDeliveredAt(e)} defaultValue={deliveredAt} />
          <input
            type="hidden"
            name="delivered_at"
            defaultValue={deliveredAt ? deliveredAt.format("YYYY-MM-DD") : ""}
          />
        </fieldset>

        <Template.SingleSelect
          withLabel
          placeholder="ساعت تحویل"
          onChange={handleChangeDeliveredTime}
          name="delivered_time"
          value={deliveredTime}
          options={[
            {
              value: "09-11",
              label: "09-11",
            },
            {
              value: "11-13",
              label: "11-13",
            },
            {
              value: "13-15",
              label: "13-15",
            },
            {
              value: "15-17",
              label: "15-17",
            }
          ]}
        />
        
      </Template.Filter>

      <div className="flex flex-row gap-3 my-5">
        <a onClick={handlePrintAll} className="bg-gradient-to-tr cursor-pointer from-blue-300 to-blue-400 hover:opacity-75 border text-xs  font-bold  px-5 py-4 flex justify-center items-center rounded-md text-gray-700 ">چاپ دسته‌ای</a>
        <a onClick={handlePrintPostAll} className="bg-gradient-to-tr cursor-pointer from-teal-300 to-teal-400 hover:opacity-75 border text-xs  font-bold  px-5 py-4 flex justify-center items-center rounded-md text-gray-700 ">برچسب دسته‌ای</a>
        <a onClick={handleTotalPrint} className="bg-gradient-to-tr cursor-pointer from-orange-300 to-orange-400 hover:opacity-75 border text-xs  font-bold  px-5 py-4 flex justify-center items-center rounded-md text-gray-700 ">خروجی انبار</a>
      </div>

      <Template.Table onSelectedRowsChange={handleSelectRows} selectableRows={true} count={totalPages} columns={columns} data={rows} />

    </div>
  );
};
